// extracted by mini-css-extract-plugin
export var alt = "SocialMedia-module--alt--396d5";
export var circleBackgroud = "SocialMedia-module--circleBackgroud--da700";
export var container = "SocialMedia-module--container--776e8";
export var desktopOnly = "SocialMedia-module--desktopOnly--d0b8c";
export var main = "SocialMedia-module--main--66521";
export var mobileOnly = "SocialMedia-module--mobileOnly--34f64";
export var socialMediaLinks = "SocialMedia-module--socialMediaLinks--84d54";
export var textLeft = "SocialMedia-module--textLeft--c5082";
export var visuallyHidden = "SocialMedia-module--visuallyHidden--eb6f5";